export const view01ImageOptions = {
  angle: 'view01',
  staticOptions: {
    BiminiColor: 1,
    BowOption: 1,
    UpholsteryCockpit: 1,
    AnchorStern: 1,
    AnchorBow: 1,
    Galley: 1
  },
  mattes: [
    {
      option: 'BiminiColor',
      dependency: 'TTop'
    },
    {
      option: 'BowOption',
      dependency: 'UpholsteryCockpit'
    },
    {
      option: 'UpholsteryCockpit',
      dependency: 'TTop'
    },
    {
      option: 'AnchorStern',
      dependency: 'Engine'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/Xpower/views/view01.js